import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets, serviceTemplate } from '@/utils'

import { countryRegionsOrderFields } from '@/components/services/country-regions/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services['country-regions'],

      backendGeneration: 'nest',

      permission: {
        get: { accept: permissionPresets.true },
        create: { accept: permissionPresets.true },
        update: { accept: permissionPresets.true },
        remove: { accept: permissionPresets.true }
      },

      find: {
        defaultFilter: {
          regionCode: undefined,
          countryCode: undefined
        }
      },

      orderFields: countryRegionsOrderFields,

      has: {
        tabs: false,
        clone: false,
        search: true
      },

      formClass: '',
      titlePath: 'regionName',
      width: 800
    })
  ]
}
